<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Claim'
}

</script>



// WEBPACK FOOTER //
// src/Osm/Claim/containers/Claim.vue